module.exports = __webpack_public_path__ + "static/media/statotech.08912b51.png";